import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Loading } from '@maui/elements'
import AddComment from './AddComment'
import CommentsList from './CommentsList'

export default function Comments({ caseId, comments }) {
  const [commentsDisplay, setCommentsDisplay] = useState(comments)

  const updateComments = useCallback((newComment) => {
    setCommentsDisplay([newComment, ...commentsDisplay])
  }, [commentsDisplay, setCommentsDisplay])

  return (
    <Box
      display='flex'
      flexDirection='column'
      height='100%'
      minHeight='100%'
      width='100%'
      color='colorTextMain'
    >
      <Box mb='spaceGapXLarge' overflow='auto' height='100%'>
        {!commentsDisplay && <Box marginTop='spaceGapMedium' marginBottom='spaceGapMedium'><Loading /></Box> }
        { (commentsDisplay && commentsDisplay.length === 0) && <Box marginTop='spaceGapMedium' marginBottom='spaceGapMedium'>No comments</Box> }
        { (commentsDisplay && commentsDisplay.length > 0) && <CommentsList comments={commentsDisplay} /> }
      </Box>
      <AddComment caseId={caseId} updateComments={updateComments} />
    </Box>
  )
}

Comments.propTypes = {
  caseId: PropTypes.string.isRequired,
  comments: PropTypes.array,
}
